<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Create new bank info</h3>
  </div>

  <!---------- main content ---------->

  <div class="dialog-content__container">
    <form [formGroup]="newBankForm">
      <div class="row bank">
        <div class="col-6 bank__first">
          <div class="mb-3 bank__item">
            <label class="label-input col-sm-5">Bank name</label>
            <div class="col-sm-3">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="bankName"
              />
            </div>
          </div>
          <div class="mb-3 bank__item">
            <label class="label-input col-sm-5">USD IBAN</label>
            <div class="col-sm-3">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="usdiban"
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3 bank__item">
            <label class="label-input col-sm-5">UAN IBAN</label>
            <div class="col-sm-3">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="uahiban"
              />
            </div>
          </div>
          <div class="mb-3 bank__item">
            <label class="label-input col-sm-5">Bank SWIFT Code</label>
            <div class="col-sm-3">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="swiftCode"
              />
            </div>
          </div>
        </div>
        <hr />
        <div class="mb-16 mt-16 bank__item">
          <label class="bank__additional">Сard number</label>
          <button
            class="button button__add--normal"
            type="button"
            (click)="createCardsGroup()"
          ></button>
        </div>
        <ng-container formArrayName="cards">
          <div
            *ngFor="let card of cardsArray.controls; let i = index"
            [formGroupName]="i"
          >
            <hr />
            <div class="row bank__group">
              <div class="row mb-3 col-6 bank__item">
                <label class="label-input col-sm-5">Card number</label>
                <div class="col-sm-3">
                  <input
                    type="text"
                    class="input__basic"
                    placeholder=" "
                    formControlName="cardNumber"
                  />
                </div>
              </div>
              <div class="row mb-3 col-6 bank__item">
                <label class="label-input col-sm-3">End date</label>
                <div class="col-sm-3">
                  <app-datepicker
                    formControlName="endDate"
                    [withoutX]="true"
                  ></app-datepicker>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <hr />
        <div class="mb-16 mt-16 bank__item">
          <label class="bank__additional"
            >Bank autentification credentials</label
          >
          <button
            class="button button__add--normal"
            type="button"
            (click)="createCredentialsGroup()"
          ></button>
        </div>
        <ng-container formArrayName="bankCredentials">
          <div
            *ngFor="
              let bankCredential of bankCredentialsArray.controls;
              let i = index
            "
            [formGroupName]="i"
          >
            <hr />
            <div class="row bank__group">
              <div class="row col-6">
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5">Login bank</label>
                  <div class="col-sm-3">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="login"
                    />
                  </div>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5">Password file path</label>
                  <div class="col-sm-5">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="passwordFilePath"
                      #passwordFilePath
                    />
                  </div>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5">Key file path</label>
                  <div class="col-sm-5">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="keyFilePath"
                    />
                  </div>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5"
                    >Backup password file path</label
                  >
                  <div class="col-sm-5">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="backupPasswordFilePath"
                    />
                  </div>
                </div>
              </div>
              <div class="row col-6">
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5"
                    >Backup key file path</label
                  >
                  <div class="col-sm-5">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="backupKeyFilePath"
                    />
                  </div>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5"
                    >Cloud password file path</label
                  >
                  <div class="col-sm-5">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="cloudPasswordFilePath"
                    />
                  </div>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5"
                    >Cloud key file path</label
                  >
                  <div class="col-sm-5">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="cloudKeyFilePath"
                    />
                  </div>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5">Comment</label>
                  <div class="col-sm-3">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="comment"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <hr />
        <div class="mb-16 mt-16 bank__item">
          <label class="bank__additional">Agreement info</label>
          <button
            class="button button__add--normal"
            type="button"
            (click)="createAgreementGroup()"
          ></button>
        </div>

        <ng-container formArrayName="agreementInfos">
          <div
            *ngFor="
              let agreement of agreementInfosArray.controls;
              let i = index
            "
            [formGroupName]="i"
          >
            <hr />
            <div class="row bank__group">
              <div class="row col-6">
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5">Agreement No</label>
                  <div class="col-sm-3">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="agreementNo"
                    />
                  </div>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5"
                    >Agreement start date</label
                  >
                  <app-datepicker
                    [withoutX]="true"
                    formControlName="agreementStartDate"
                    [iconLeft]="true"
                  ></app-datepicker>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5">Agreement end date</label>
                  <app-datepicker
                    [withoutX]="true"
                    formControlName="agreementEndDate"
                    [iconLeft]="true"
                  ></app-datepicker>
                </div>
              </div>
              <div class="row col-6">
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5">NDA</label>
                  <div class="col-sm-5 nda-dropdown">
                    <app-dropdown
                      [items]="data.dropdown"
                      formControlName="nda"
                    ></app-dropdown>
                  </div>
                </div>
                <div class="bank__item mb-3">
                  <label class="label-input col-sm-5">Comment</label>
                  <div class="col-sm-3">
                    <input
                      type="text"
                      class="input__basic"
                      placeholder=" "
                      formControlName="comment"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>

  <!--  save/cancel buttons -->
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="save()">
        Save
      </button>
      <button class="button button__cancel" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
